export const INPUT_SHEET_HEADER_ALIAS = 'input_sheet_header';
